<template>
  <div class="card text-white text-left mb-5">
    <div class="maskot">
      <img src="~@/assets/img/maskot.png" class="maskot-img">
    </div>
    <div class="card-body monaco pt-5">
      <details>
        <summary><strong>Case 4: Hapus NOL</strong></summary>
        <p>
          <br>
          <strong>Story</strong>: <br>
          Hapus NOL dari rentang tertenu!
          <br><br>
          <strong>Contoh <em>input</em> 1</strong>: <br>
          <pre>
            start: -3
            end: 3
          </pre>
          <strong>Contoh <em>output</em> 1</strong>: <br>
          <pre>
            -3
            -2
            -1
            1
            2
            3
          </pre>
        </p>
      </details>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      nama: '',
      kelas: '',
      jawaban: '',
      submited: false,
      sending: false,
    }
  },

  methods: {
    async submitAnswer() {
      this.sending = true
      let { data, error } = await this.$supabase
      .from('score2023')
      .insert([
        {
          email: this.email,
          nama: this.nama,
          kelas: this.kelas,
          jawaban: this.jawaban,
          case: 1
        }
      ])

      this.sending = false
      if (data) {
        this.submited = true
        this.email = ''
        this.nama = ''
        this.kelas = ''
        this.jawaban = ''
      }
    }
  }
};
</script>

<style scoped>
details {
  margin: 20px 0 20px 0;
}
pre {
  padding: 20px;
  padding-left: 0;
  padding-right: 0;
  color: #fff;
  background-color: #0b0b0b;
  border-top: 3px solid #fff;
  border-bottom: 3px solid #fff;
}
</style>
